class DynamicContentOpeners extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll("[dynamic-content-opener]");

    if (!this.items || !this.items.length) {
      throw new Error("No dynamic content openers found");
    }

    this.dynamicContent = document.querySelector(this.getAttribute("data-content"));

    if (!this.dynamicContent) {
      throw new Error("No dynamic content found");
    }

    this.items.forEach(item => {
      item.addEventListener("click", () => this.onClick(item));
    });
  }

  onClick(item) {
    const id = item.getAttribute("data-id");

    if (!id) {
      throw new Error("No dynamic content id found");
    }

    this.dynamicContent.show(id);

    this.items.forEach(item => {
      item.getAttribute("data-id") === id ? item.classList.add("active") : item.classList.remove("active");
    });
  }
}

customElements.define("dynamic-content-openers", DynamicContentOpeners);

class DynamicContent extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll(".dynamic-content__item");
    this.hasScrolled = false;

    if (!this.items || !this.items.length) {
      throw new Error("No dynamic content items found");
    }
  }

  show(id) {
    this.items.forEach(item => {
      item.getAttribute("data-id") === id ? item.classList.add("active") : item.classList.remove("active");
    });

    if (window.window.innerWidth > 990 && this.hasScrolled) return;

    this.scrollIntoView({top: -200, behavior: "smooth"});
    this.hasScrolled = true;
  }
}
customElements.define("dynamic-content", DynamicContent);
